import { requiredAssetsToAssetMap } from 'shared/util/asset-map';

// @ts-expect-error require.context is not defined in types
const images = () => requiredAssetsToAssetMap(require.context('@/static/logo/supplier/66x22', false, /\.png$/));

export default images;
